<div class="sidenav sidebar py-3" id="sidebar">
  <h6 class="sidebar-heading">Admin</h6>
  <ul class="list-unstyled">
    <li class="sidebar-list-item" (click)="NavClick('/dashboard')"><span class="sidebar-link text-muted">
        <svg class="svg-icon svg-icon-md me-3">
          <use xlink:href="assets/icons/orion-svg-sprite.svg#real-estate-1"> </use>
        </svg><span class="sidebar-link-title">Dashboard</span></span></li>
    <li class="sidebar-list-item" (click)="NavClick('/all-forms')"><span class="sidebar-link text-muted">
        <svg class="svg-icon svg-icon-md me-3">
          <use xlink:href="assets/icons/orion-svg-sprite.svg#table-content-1"> </use>
        </svg><span class="sidebar-link-title">All forms</span></span></li>
    <li class="sidebar-list-item" (click)="NavClick('/view-submissions')"><a class="sidebar-link text-muted">
        <svg class="svg-icon svg-icon-md me-3">
          <use xlink:href="assets/icons/orion-svg-sprite.svg#keyboard-1"> </use>
        </svg><span class="sidebar-link-title">View Submissions</span></a></li>
    <div class="" dropdown>
      <li dropdownToggle class="sidebar-list-item"><a (click)="toggleArrow()" class="sidebar-link text-muted"
          role="button" [attr.aria-expanded]="arrowExpand" data-bs-toggle="collapse">
          <svg class="svg-icon svg-icon-md me-3">
            <use xlink:href="assets/icons/orion-svg-sprite.svg#man-1"> </use>
          </svg><span class="sidebar-link-title">Users</span></a>
        <ul [ngClass]="{'hide': arrowExpand == false}" *dropdownMenu class="sidebar-menu list-unstyled" id="userDropdown">
          <li class="sidebar-list-item" (click)="NavClick('/add-users',1)"><a
              [ngClass]="{'active': currentsubMenu === 1}" class="sidebar-link text-muted">Manage
              Users</a></li>
          <li class="sidebar-list-item"><a [ngClass]="{'active': currentsubMenu === 2}"
              (click)="NavClick('/view-submissions',2)" class="sidebar-link text-muted">Manage Groups </a></li>
        </ul>
      </li>
    </div>
    <li class="sidebar-list-item" (click)="NavClick('/facilities')"><a class="sidebar-link text-muted">
        <svg class="svg-icon svg-icon-md me-3">
          <use xlink:href="assets/icons/orion-svg-sprite.svg#real-estate-1"> </use>
        </svg><span class="sidebar-link-title">Facilities</span></a>
    </li>
  </ul>
</div>